import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { Card, Row, Col, Spin, Popover, Image} from 'antd';
import { EditOutlined, EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import imgBasic from '../../img/Stand_Small.png';
import imgMedium from '../../img/medium.png';
import imgPremium from '../../img/premium.png';
import apiConnect from '../../config/apiConfig';
import styles from './myStands.module.scss';

const MyStands = () => {
  const {
    container,
    card,
    row,
    col,
    listContainer,
    divider,
    key,
    value,
    spin,
    loadContainer
  } = styles;

  const id = localStorage.getItem('id');

  const [stands, setStands] = useState([]);
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const iconSpin = <LoadingOutlined spin className={spin}/>;

  useEffect(() => {
    const getStands = async () => {
      try {
        setLoading(true);
        const { data } = await apiConnect.get(`/users/${id}/stands`);
        setStands(data.data);
        setLoading(false);
      } catch(error) {
        console.log(error); //eslint-distable-line
      }
    };
    
    getStands();
  }, []);

  const { Meta } = Card;

  const description = (stand) => {
    return(
      <>
        <div className={listContainer}>
          <span className={key}>N° de stands</span>
          <span className={value}>#{stand.standNumber}</span>
        </div>
        <hr className={divider}/>
        <div className={listContainer}>
          <span className={key}>Tipo</span>
          <span className={value}>{
            (stand.type === 'standard' && 'Basico') ||
            (stand.type === 'intermediate' && 'Medium') ||
            (stand.type === 'full' && 'Premium')
          }
          </span>
        </div>
        <hr className={divider}/>
        <div className={listContainer}>
          <span className={key}>Hall</span>
          <span className={value}>{stand.section}</span>
        </div>
      </>
    );
  };
  
  return (
    <div className={container}>
      <h2>Mis stands</h2>
      { loading ? (
        <div className={loadContainer}>
          <Spin indicator={iconSpin}/>
        </div>
      ) : (
        <Row gutter={[16,20]} className={row}>
          {stands.map(stand => {
            return(
              <Col span={6} key={stand._id} className={col}>
                <Card
                  className={card}
                  hoverable={true}
                  bordered={false}
                  cover={
                    <Image preview={false}
                      src={
                        (stand.type === 'standard' && imgBasic) ||
                        (stand.type === 'intermediate' && imgMedium) ||
                        (stand.type === 'full' && imgPremium)
                      }
                      alt="stand"
                    />
                  }
                  actions={[
                    <Popover
                      key='edit'
                      content='Editar un stand'
                    >
                      <EditOutlined
                        key='edit'
                        onClick={() => history.push(`/provider/stand/${stand._id}`)}
                      />
                    </Popover>,
                    <Popover
                      key='view'
                      content='Vista previa del stand'
                    >
                      <EyeOutlined
                        onClick={() => history.push(`/provider/stand/view/${stand._id}`)}
                      />
                    </Popover>
                  ]}
                >
                  <Meta
                    title={`${stand.name ? stand.name : ''}`}
                    description={description(stand)}
                  />
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
};

export default MyStands;